import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SKIP_NOTIFICATION } from '~core/interceptors/error-handler.interceptor';
import { environment } from 'src/environments/environment';
import { ChangeStatusData, EffectStatusData } from '~shared/types/websockets.types';

export interface ProjectStatusResponse {
	projectId: string;
	changes: ChangeResponse[];
	hasPendingEffects: boolean;
}

export interface ChangeResponse {
	correlationId: string;
	description?: string;
	identifier: Record<string, string>;
	originator: string;
	initiatedBy?: string;
	createdAt: string;
	effects: EffectStatusData[];
	pending: number;
	inProgress: number;
	completed: number;
	failed: number;
}

@Injectable({ providedIn: 'root' })
export class EffectStatusService {
	private baseUrl = environment.changetrackerServiceUrl + 'manifest';

	constructor(private http: HttpClient) {}

	getProjectStatus(projectId: string): Observable<ProjectStatusResponse> {
		return this.http.get<ProjectStatusResponse>(`${this.baseUrl}/project/${projectId}/status`, {
			context: new HttpContext().set(SKIP_NOTIFICATION, true),
		});
	}

	deleteChange(correlationId: string): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/change/${correlationId}`, {
			context: new HttpContext().set(SKIP_NOTIFICATION, true),
		});
	}

	deleteAllChanges(projectId: string): Observable<{ deleted: number }> {
		return this.http.delete<{ deleted: number }>(`${this.baseUrl}/project/${projectId}/changes`, {
			context: new HttpContext().set(SKIP_NOTIFICATION, true),
		});
	}

	getPendingChanges(projectId: string): Observable<ChangeStatusData[]> {
		return this.http.get<ProjectStatusResponse>(`${this.baseUrl}/project/${projectId}/status`, {
			context: new HttpContext().set(SKIP_NOTIFICATION, true),
			params: { status: ['PENDING', 'IN_PROGRESS'] },
		}).pipe(
			map(status => status.changes.map(c => ({
				correlationId: c.correlationId,
				description: c.description,
				originator: c.originator,
				createdAt: c.createdAt,
				effects: c.effects,
			})))
		);
	}
}
